import type { Dtos, SuretyQuoteId } from "@inrev/common";

export const pelPmlQueryKey = () => ["pel-pml"] as const;

export type PelPmlCalculationInput = Dtos.Admin.PelPml.Calculate.Request;

export const pelPmlCalculationQueryKey = (input: PelPmlCalculationInput | null) =>
	[...pelPmlQueryKey(), "calculation", input] as const;

export type PelPmlForQuoteOverrides = Dtos.Admin.PelPml.ForQuote.Request;

export const EMPTY_PEL_PML_FOR_QUOTE_OVERRIDES: PelPmlForQuoteOverrides = {};

export const pelPmlForQuoteQueryKey = (
	quoteId: SuretyQuoteId,
	overrides: PelPmlForQuoteOverrides,
) => [...pelPmlQueryKey(), "quotes", quoteId, overrides] as const;
